import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CountUp"] */ "/vercel/path0/src/components/CountUp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleMap"] */ "/vercel/path0/src/components/GoogleMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialMediaEinblicke"] */ "/vercel/path0/src/components/SocialMediaEinblicke.tsx");
